<template>
  <v-data-table
    v-model="value.selected"
    :items="value.items"
    :headers="headers"
    :options.sync="value.options"
    :loading="value.loading"
    item-key="id"
    class="elevation-0"
  >
    <template v-slot:item.month="{ item }">
      {{ convertMonth(item.month) }}
    </template>

    <template v-slot:item.created="{ item }">
      {{ dateFormatting(item.created)  || missingValueString }}
    </template>

    <template v-slot:item.url="{ item }">
      <div class="d-flex align-center">
        <a v-if="item.url" :href="item.url" @click.prevent="fileDownload($event, item.uuid)">
          {{ item.name }}
        </a>
      </div>
    </template>
    <template v-slot:item.status="{ item }">
      <div class="d-flex align-center">
        <v-chip v-if="item.complaint" class="white--text" color="#781717" label>
          V REKLAMACI
        </v-chip>
        <v-chip v-else-if="item.notAvailable" class="white--text" color="#781717" label>
          NENÍ K DISPOZICI
        </v-chip>
      </div>
    </template>
  </v-data-table>
</template>

<script>
import { downloadFile } from '@/components/mixins/downloadFile';

export default {
  name: 'TableAgreementAttachment',
  props: {
    value: {
      type: Object,
      required: true,
      default() {
        return [];
      },
    },
    loading: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  mixins: [downloadFile],
  data() {
    return {
      headers: [
        {
          text: 'Období',
          value: 'month',
          width: '90px',
        },
        {
          text: 'Datum generováni',
          value: 'created',
          width: '90px',
        },
        {
          text: 'Příloha rámcové smlouvy',
          value: 'url',
          width: '200px',
        },
        {
          text: '',
          value: 'status',
          width: '200px',
        },
      ],
      baseUrl: process.env.VUE_APP_BACKEND,
    };
  },
  methods: {
    fileDownload(event, uuid) {
      this.downloadFile(event, `requests/files/${uuid}`);
    },
    convertMonth(monthOrder) {
      switch (monthOrder) {
        case 1:
          return 'Leden';
        case 2:
          return 'Únor';
        case 3:
          return 'Březen';
        case 4:
          return 'Duben';
        case 5:
          return 'Květen';
        case 6:
          return 'Červen';
        case 7:
          return 'Červenec';
        case 8:
          return 'Srpen';
        case 9:
          return 'Září';
        case 10:
          return 'Říjen';
        case 11:
          return 'Listopad';
        case 12:
          return 'Prosinec';
        default:
          return null;
      }
    },
  },
  watch: {
    'value.options': {
      handler(options) {
        this.$store.commit('settings/TABLE_ITEMS_UPDATE', {
          tableName: 'agreementAttachmentList',
          itemsPerPage: options.itemsPerPage,
        });
        this.$emit('onChangeOptions', this.value);
      },
    },
  },
};
</script>
